import React from 'react';
import { Link } from 'react-router-dom';

export default function Hero() {
  const scrollToContact = () => {
    try {
      const element = document.getElementById('contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      } else {
        console.warn('Element with id "contact" not found.');
      }
    } catch (error) {
      console.error('Failed to scroll to contact section:', error);
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden bg-matte-black">
      <div className="absolute inset-0 w-full h-full flex items-center justify-center">
        <img
          src="https://public.readdy.ai/ai/img_res/10b8c533-a6b8-47c2-93aa-30ef2f97bea9.png"
          alt=""
          className="w-[1200px] h-auto opacity-[0.15]"
        />
      </div>

      <div className="relative z-10 w-full px-8 lg:px-16 py-32 pt-56">
        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-7xl mx-auto">
          <div className="text-white">
            <p className="text-xs uppercase tracking-[0.3em] mb-8 font-semibold text-neon-green">
              Pennsylvania&apos;s Premier Roofing Experts
            </p>
            <h1 className="mb-8 leading-none" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
              <span className="block text-7xl lg:text-[6.5rem] text-white tracking-wide">BUILT TOUGH.</span>
              <span className="block text-7xl lg:text-[6.5rem] text-neon-green tracking-wide">BUILT IRONCORE.</span>
            </h1>
            <p 
              className="text-xl lg:text-2xl leading-relaxed max-w-xl mb-12 text-white/90 tracking-wide"
              style={{ fontFamily: "'Oswald', sans-serif", fontWeight: 300 }}
            >
              IronCore Roofing and Exteriors delivers unmatched craftsmanship in roofing, storm restoration, siding, and gutters. We protect what matters most — your home and family.
            </p>
            <div className="flex flex-wrap gap-4 mb-12">
              {['Roofing', 'Roof Repairs', 'Storm Restoration', 'Siding', 'Gutters'].map((item) => (
                <span key={item} className="flex items-center gap-2 text-sm text-white/80">
                  <i className="ri-checkbox-circle-fill text-neon-green"></i>
                  {item}
                </span>
              ))}
            </div>
            <Link
              to="/contact"
              className="group bg-neon-green text-matte-black px-12 py-4 rounded-lg font-semibold text-sm flex items-center gap-3 hover:bg-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Get a Free Estimate
              <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform"></i>
            </Link>
          </div>

          <div className="hidden lg:block">
            <div className="relative w-full h-full" style={{ width: '100%', height: '600px' }}>
              <img
                src="https://public.readdy.ai/ai/img_res/5824bc2c8b6e5e40d8c915e349b56d30.jpg"
                alt="Happy family in front of home with new roof"
                className="w-full h-full object-cover object-top rounded-3xl shadow-2xl border-2 border-neon-green/30"
              />
              <div className="absolute -bottom-4 -left-4 bg-neon-green text-matte-black px-6 py-3 rounded-lg font-bold text-sm shadow-lg">
                <i className="ri-shield-check-fill mr-2"></i>
                100% Satisfaction Guaranteed
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
